import styled from "styled-components";
import React from "react";
import {getTheme} from "../shared/themeUtils";

const Contain = styled.div`
    background-image: url("/client-images/contour-line.svg");
    background-color: ${getTheme("colors.background")};
    background-size: cover;
    padding: ${getTheme("space.3")};
    margin: ${getTheme("space.2")} 0;
    border-radius: ${getTheme("borderRadius")};
    display: flex;
    justify-content: space-between;
    align-items: center;

    .internal {
        color: ${getTheme("colors.internal")};
    }
    
    @media (max-width: ${getTheme("breakpoints.0")}) {
      padding: 0;
      background: none;
      font-size: 1em!important;
    }
`;

type TitleAreaPropsType = {
    title: string,
    subtitle?: string,
    className?: string,
    children?: React.ReactNode,
  internal?: boolean
}

const TitleArea = (props: TitleAreaPropsType) => {
  const {title, subtitle, className, children, internal} = props;
    return (
        <Contain>
            <div>
              <h1 className={internal ? `${className} internal` : className}>{title}</h1>
                {subtitle && <div className="subtitle text-muted">{subtitle}</div>}
            </div>
            {children}
        </Contain>
    )
}

export default TitleArea;
